
import { faYoutube } from '@fortawesome/free-brands-svg-icons'
import { faLocationArrow } from '@fortawesome/pro-regular-svg-icons'
import { faPawSimple } from '@fortawesome/pro-solid-svg-icons'

export default {
  name: 'PageIndex',

  data() {
    return {
      postcode: null,
      isVideoPlaying: false,
      faLocationArrow,
      faPawSimple,
      faYoutube
    }
  },

  head() {
    return {
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'Paw Paddock is an Exclusive, Enclosed and Secure Dog Walking facility. We have more than 6 paddocks for you to choose from across the South Coast'
        }
      ]
    }
  },

  computed: {
    compYoutubeUrl() {
      if (this.isVideoPlaying) {
        return 'https://www.youtube.com/embed/UKxsAcfr6TM?autoplay=1&mute=1&showinfo=0&modestbranding=1&playsinline=1&loop=1&cc_load_policy=0&iv_load_policy=3&playlist=UKxsAcfr6TM'
      } else {
        return 'https://www.youtube.com/embed/UKxsAcfr6TM?autoplay=1&mute=1&controls=0&showinfo=0&mute=1&autohide=1&modestbranding=1&playsinline=1&loop=1&cc_load_policy=0&iv_load_policy=3&playlist=UKxsAcfr6TM'
      }
    }
  },

  created() {
    this.$store.dispatch('paddocks/fetchAll')
  },

  methods: {
    openHowWorksVideo() {
      this.$analytics.addEvent('clicked how it works video', { page: 'home' })

      this.$modal.open('global/how-it-works-video')
    },

    playVideo() {
      this.isVideoPlaying = true
    },

    onPaddockSelected(paddock) {
      this.$redirect.to(`/paddocks/${paddock.slug}`)
    },

    onPaddockBook(paddock) {
      this.$redirect.to(`/book/${paddock.slug}`)
    }
  }
}
